import { settings, internalSettings } from 'ads';
import { useEffect, useRef, useState } from 'react';
import { uniqueId } from 'underscore';

import { GoogleAdsPlugin, YandexAdsPlugin } from 'integrations';
import { GoogleAdsOrientation } from 'integrations/google/ads';
import { AuthService, UserClaims } from 'shared/mechanics/auth';

import styles from './index.module.scss';
import { showAuthPopup } from 'shared/auth';

export interface AdsProps {
	id: string;
	isVertical: boolean;
}

export const AdsComponent = (props: AdsProps) => {
	const id = useRef(uniqueId());
	const divRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (divRef.current == null)
			return;

		YandexAdsPlugin.render(
			setting.yandexId,
			id.current,
			() => {
				if (setting.googleId) {
					GoogleAdsPlugin.render(
						setting.googleId,
						id.current,
						props.isVertical ? GoogleAdsOrientation.Vertical : GoogleAdsOrientation.Horizontal);
				}
			});

	}, [divRef])

	const userAuthorization = AuthService.resolveUserAuthorization();
	if (userAuthorization.haveClaim(UserClaims.NO_ADS))
		return null;

	const setting = settings[props.id];
	if (!setting)
		return null;

	const [renderer, showRemoveAdBlock] = adsRenderer();

	return (
		<div style={{ minWidth: '200px', display: 'flex', flexDirection: 'column', height: '100%' }}>
			<div style={{ flex: '1' }}>
				{ renderer() }
			</div>
			{
				showRemoveAdBlock 
					? (
						<div style={{ flex: '0', textAlign: 'center' }}>
							<RegisterToRemoveAds />
						</div>
					)
					: null
			}
		</div>
	);

	function adsRenderer(): [componentRenderer: () => JSX.Element, showRemoveAdBlock: boolean] {
		if (setting.internalId) {
			var internalSetting = internalSettings[setting.internalId];
			if (internalSetting && internalSetting.isEnabled)
			{
				return [() => internalSetting.component(), internalSetting.showRemoveAdBlock];
			}
		}

		return [() => <div id={id.current} ref={divRef} style={{ height: '100%' }}></div>, true];
	}
}

const RegisterToRemoveAds = () => {
	return (
		<a href="#" className={styles.register_for_remove_ads} onClick={() => showAuthPopup({ title: 'Отключение рекламы в подписке' })}>Убрать рекламу</a>
	);
}